<template>
  <div>
    <div
      class="content-devx register-screen"
    >
      <DxForm
        id="costForm"
      >
        <DxGroupItem
          css-class="content-combo"
          :col-count="2"
        >
          <DxSimpleItem
            name="name"
            :data-field="$t('newUser.newUser_name')"
            :editor-options="{
              value: newUser.name,
              onValueChanged: onChangeName,
              placeholder: ''
            }"
          >
            <DxRequiredRule :message="$t('newUser.DxCostForm_Id_required')" />
          </DxSimpleItem>
          <DxSimpleItem
            name="surname"
            :data-field="$t('newUser.newUser_surname')"
            :editor-options="{
              value: newUser.surname,
              onValueChanged: onChangeSurname,
              placeholder: ''
            }"
          >
            <DxRequiredRule :message="$t('newUser.DxCostForm_Id_required')" />
          </DxSimpleItem>
          <DxSimpleItem
            name="province"
            :data-field="$t('newUser.newUser_province')"
            editor-type="dxSelectBox"
            :editor-options="{
              items: provinces,
              value: newUser.province,
              displayExpr: 'value',
              valueExpr: 'id',
              searchEnabled: true,
              onValueChanged: onChangeProvince,
              placeholder: $t('newUser.newUser_selectBox'),
            }"
          >
            <DxRequiredRule :message="$t('newUser.DxCostForm_Id_required')" />
          </DxSimpleItem>
          <DxSimpleItem
            name="email"
            :data-field="$t('newUser.newUser_email')"
            :editor-options="{
              value: newUser.email,
              onValueChanged: onChangeEmail,
              placeholder: ''
            }"
          >
            <DxRequiredRule :message="$t('newUser.DxCostForm_Id_required')" />
          </DxSimpleItem>
          <DxSimpleItem
            name="password"
            :data-field="$t('newUser.newUser_password')"
            :editor-options="{
              value: newUser.password,
              onValueChanged: onChangePassword,
              mode: 'password',
              placeholder: ''
            }"
          >
            <DxRequiredRule :message="$t('newUser.DxCostForm_Id_required')" />
          </DxSimpleItem>
          <DxSimpleItem
            name="confirmEmail"
            :data-field="$t('newUser.newUser_confirmEmail')"
            :editor-options="{
              value: newUser.confirmEmail,
              onValueChanged: onChangeConfirmEmail,
              placeholder: ''
            }"
          >
            <DxRequiredRule :message="$t('newUser.DxCostForm_Id_required')" />
          </DxSimpleItem>
          <DxSimpleItem
            name="confirmPassword"
            :data-field="$t('newUser.newUser_confirmPassword')"
            :editor-options="{
              value: newUser.confirmPassword,
              onValueChanged: onChangeConfirmPassword,
              mode: 'password',
              placeholder: ''
            }"
          >
            <DxRequiredRule :message="$t('newUser.DxCostForm_Id_required')" />
          </DxSimpleItem>
        </Dxgroupitem>
      </DxForm>
    </div>
    <div class="register-screen">
      <f7-row>
        <f7-col>
          <f7-button
            name="btnSignIn"
            class="botonSecundary"
            col
            button
            button-raised
            fill
            style="color:#FFFFFF"
            @click="back"
          >
            {{ $t("Login_back") }}
          </f7-button>
        </f7-col>
        <f7-col>
          <f7-button
            name="btnSignIn"
            class="botonPrimary"
            col
            button
            button-raised
            fill
            style="color:#FFFFFF"
            @click="register"
          >
            {{ $t("Login_register") }}
          </f7-button>
        </f7-col>
      </f7-row>
    </div>
  </div>
</template>
<script>

import { mapState, mapActions } from 'vuex';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxRequiredRule,
} from 'devextreme-vue/form';
import * as overlay from 'devextreme/ui/overlay';
import Api from '../../services/Api';

export default {
  name: 'NewUser',
  components: {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxRequiredRule,
  },
  props: {
    editForm: { type: Boolean, default: false },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('NewRegister', ['isNewUser', 'newUser']),
    ...mapState('ProjectGreenHouse', ['provinces']),

    currencyCodeValue() {
      return this.editForm === true ? this.actualCost.currency_code : this.actualCurrencyCode;
    },
  },
  async beforeMount() {
    this.$f7.preloader.show();
    try {
      await this.fetchProvinces();
    } catch (e) {
      const message = this.$helpers.getFilteredErrorMessage(e);
      if (message.includes('default_') && !message.includes('404')) {
        this.$f7.dialog.alert(message.split('_').pop());
      } else if (!message.includes('404')) {
        this.$f7.dialog.alert(this.$t(message));
      }
    } finally {
      this.$f7.preloader.hide();
    }
  },
  methods: {
    back() {
      this.setIsNewUser(false);
    },
    async register() {
      console.log(this.newUser);
      this.$f7.preloader.show();
      try {
        const data = {
          email: this.newUser.email,
          password: this.newUser.password,
          email2: this.newUser.confirmEmail,
          password2: this.newUser.confirmPassword,
          first_name: this.newUser.name,
          last_name: this.newUser.surname,
          province: this.newUser.province,
        };
        await Api.register(data);
        this.setIsNewUser(false);
        this.resetNewProject();
        this.resetNewProjectOpenAir();
        this.$f7.views.main.router.navigate('/selection/', { reloadCurrent: true });
        await Api.getProfile();
      } catch (reason) {
        const message = this.$helpers.getFilteredErrorMessage(reason);
        if (message.includes('incorrect authentication')) {
          this.$f7.dialog.alert(this.$t(message));
        }
        if (message.includes('default_') && !message.includes('404')) {
          this.$f7.dialog.alert(message.split('_').pop());
        } else if (!message.includes('404')) {
          this.$f7.dialog.alert(this.$t(message));
        }
      } finally {
        this.$f7.preloader.hide();
      }
      // this.resetNewUser();
    },
    onChangeName(e) {
      this.setName(e.value);
    },
    onChangeProvince(e) {
      this.setProvince(e.value);
    },
    onChangeTypeInscription(e) {
      this.setTypeInscription(e.value);
    },
    onChangeEmail(e) {
      this.setEmail(e.value);
    },
    onChangePassword(e) {
      this.setPassword(e.value);
    },
    onChangeSurname(e) {
      this.setSurname(e.value);
    },
    onChangeConfirmPassword(e) {
      this.setConfirmPassword(e.value);
    },
    onChangeConfirmEmail(e) {
      this.setConfirmEmail(e.value);
    },
    ...mapActions('NewRegister', ['setName', 'setProvince', 'setIsNewUser', 'setTypeInscription', 'setEmail', 'setPassword',
      'setSurname', 'setConfirmPassword', 'resetNewUser', 'setConfirmEmail']),
    ...mapActions('ProjectGreenHouse', ['fetchProvinces', 'resetNewProject']),
    ...mapActions('ProjectOpenAir', ['resetNewProjectOpenAir']),
  },
};
</script>

<style lang="scss" scoped>
    .content-devx {
        width: auto;
        background: #F7F8FA;
        border: 1px solid #D4DCE1;
        box-sizing: border-box;
        border-radius: 6px;
        box-shadow: none;
    }
  .content-combo{
    .dx-item{
      .dx-item-content{
        label{
          min-width: 160px;
        }
      }
    }
  }
    .botonPrimary {
      box-shadow: none;
    }
    .botonSecundary {
      box-shadow: none;
    }

    .register-screen {
      margin: 1rem !important;
    }
</style>
